define('views/components/customer_manager/customer_manager_list',['require','views/base/list_view','views/components/customer_manager/customer_manager','text!templates/components/customer_manager/customer_manager_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/customer_manager/customer_manager');

    var temp = require("text!templates/components/customer_manager/customer_manager_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

